import {getStack} from '@ns/ns-contentstack-lib';
import {RunConfigService} from '@nuskin/ns-util';
import {CheckoutModeService} from '@nuskin/ns-shop';
import {UserService} from '@nuskin/ns-account';

/**
 * get psv label for customer
 * @param {object} strings - current translations
 * @return {string} psv label
 * @private
 */
function _getPsvLabel(strings) {
    const accountType = UserService.getUser().accountType;
    const accountTypeName = CheckoutModeService.isGuestCheckout() ? 'Anon' :
        accountType === '10' ? 'Dist' :
            accountType === '20' ? 'Cust' : 'Pfc';
    return strings[`psv${accountTypeName}`];
}

/**
 * Get translations for checkout
 * @return {Promise<object>} strings - translations for checkout
 */
export async function getStrings() {
    /** @type {import('contentstack').Stack} */
    const Stack = getStack();
    const runConfig = RunConfigService.getRunConfig();
    const lang = runConfig.language === 'in' ? 'id' : runConfig.language;

    const contentTypes = [
        'cart_general_strings',
        'checkout_adr_strings',
        'checkout_cart_strings',
        'checkout_common_strings',
        'checkout_error_strings',
        'checkout_order_confirmation_strings',
        'checkout_review_strings',
        'checkout_ship_method_strings',
        'checkout_wr_strings',
        'payment_component'
    ];

    const stringList = await Stack.getSingletonEntries({
        contentTypeUIDs: contentTypes,
        country: runConfig.country,
        language: lang,
        camelcase: true,
        mergeWithFallback: true
    });

    const strings = stringList.reduce((result, current) => {
        return Object.assign(result, current);
    }, {});

    strings.psvLabel = _getPsvLabel(strings);

    return strings;
}
